import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { Progress } from "~/components/ui/progress";

const STEPS = [
  { path: "/onboarding", label: "Welcome" },
  { path: "/onboarding/provider", label: "Provider" },
  { path: "/onboarding/test-connection", label: "Test" },
  { path: "/onboarding/templates", label: "Templates" },
  { path: "/onboarding/complete", label: "Complete" },
];

function OnboardingLayout() {
  const location = useLocation();
  const currentStepIndex = STEPS.findIndex((step) => step.path === location.pathname);
  const progressValue =
    currentStepIndex >= 0 ? ((currentStepIndex + 1) / STEPS.length) * 100 : 0;

  const isWelcome = location.pathname === "/onboarding";
  const isComplete = location.pathname === "/onboarding/complete";

  return (
    <div className="bg-background flex min-h-screen flex-col">
      {!isWelcome && !isComplete && (
        <header className="border-b px-6 py-4">
          <div className="mx-auto max-w-2xl">
            <div className="mb-4 flex items-center justify-between text-sm">
              <span className="text-muted-foreground">
                Step {currentStepIndex} of {STEPS.length - 2}
              </span>
              <span className="text-muted-foreground font-medium">
                {STEPS[currentStepIndex]?.label}
              </span>
            </div>
            <Progress value={progressValue} className="h-2" />
          </div>
        </header>
      )}
      <main className="flex flex-1 items-center justify-center p-6">
        <div className="w-full max-w-3xl">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export const Route = createFileRoute("/(authenticated)/onboarding")({
  component: OnboardingLayout,
});
